/**
 * Loads (once per session) the sync-state classification catalog every status
 * pill colours from, then re-renders so pills already on screen pick up their
 * tone. Composed through `Inherit` by every screen that renders a status pill
 * (Reports, the user page) so the rule exists once.
 *
 * `this.data.fetchSyncStateCatalog` memoises the request and never throws; a
 * failure resolves to `null`, and the next call retries.
 *
 * State it owns:
 *  - `syncStateCatalogLoadedAt` — set only to force a re-render after the
 *    catalog lands; nothing reads the value.
 *  - `syncStateCatalogFailed` — true after a failed load so the screen can show
 *    a notice with a retry instead of silently grey pills.
 */
class SyncStateCatalogController {
    async loadSyncStateCatalog() {
        const catalog = await this.data.fetchSyncStateCatalog();
        if (this._unmounted) return catalog;
        if (catalog) {
            this.setState({ syncStateCatalogLoadedAt: Date.now(), syncStateCatalogFailed: false });
        } else {
            this.setState({ syncStateCatalogFailed: true });
        }
        return catalog;
    }
}

export default SyncStateCatalogController;
